import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PartnersIcon = function PartnersIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M19.4993 13.0721L11.9993 20.5001L4.49932 13.0721C4.00463 12.5907 3.61497 12.0121 3.35487 11.3727C3.09478 10.7333 2.96989 10.047 2.98806 9.35699C3.00624 8.66697 3.16709 7.98819 3.46048 7.36339C3.75388 6.73859 4.17346 6.18131 4.69281 5.72663C5.21216 5.27196 5.82003 4.92974 6.47814 4.72154C7.13624 4.51333 7.83033 4.44364 8.51669 4.51686C9.20306 4.59007 9.86682 4.80461 10.4662 5.14696C11.0656 5.48931 11.5876 5.95205 11.9993 6.50605C12.4129 5.95608 12.9355 5.49738 13.5344 5.15866C14.1334 4.81994 14.7958 4.6085 15.4803 4.53757C16.1647 4.46665 16.8564 4.53775 17.5121 4.74645C18.1678 4.95514 18.7734 5.29693 19.2909 5.75042C19.8084 6.20391 20.2268 6.75934 20.5197 7.38195C20.8127 8.00456 20.9741 8.68094 20.9936 9.36876C21.0132 10.0566 20.8906 10.741 20.6335 11.3793C20.3763 12.0176 19.9902 12.5959 19.4993 13.0781",
      stroke: "#1C1327",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.9998 6.5L8.70685 9.793C8.51938 9.98053 8.41406 10.2348 8.41406 10.5C8.41406 10.7652 8.51938 11.0195 8.70685 11.207L9.24985 11.75C9.93985 12.44 11.0598 12.44 11.7498 11.75L12.7498 10.75C13.3466 10.1533 14.1559 9.81803 14.9998 9.81803C15.8438 9.81803 16.6531 10.1533 17.2498 10.75L19.4998 13",
      stroke: "#1C1327",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5 16L14.5 18",
      stroke: "#1C1327",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15 13.5L17 15.5",
      stroke: "#1C1327",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};